<template>
  <amp-video-iframe
    data-block-on-consent
    src="https://live.primis-amp.tech/content/video/amp/videoIframe.php?s=120450"
    width="16"
    height="9"
    layout="responsive"
    style="overflow: visible; width: 100%"
  >
  </amp-video-iframe>
</template>

<script>
export default {
  name: 'ArticleAmpVideoBanner'
}
</script>
